import clsx from "clsx";

import CategoryMenu from "@components/CategoryMenu";
import SearchInput from "@components/SearchInput";

const EntryFilter = ({
	categoryGroups,
	selectedCategory,
	isFetching,
	handleSearch,
	initialValue = "",
}) => {
	return (
		<div
			className={clsx(
				"EntryFilter",
				"max-w-screen-xl mx-auto",
				"lg:flex mb-15 px-5 xl:px-0"
			)}
		>
			<div
				className={clsx(
					"EntryFilter__categoryListboxes",
					"md:flex",
					"md:space-x-15  mb-3 lg:mb-0"
				)}
			>
				{categoryGroups.map((group) => {
					if (!group.categories || group.categories?.length === 0) return null;

					// Determine whether the selected category is in this group

					const label =
						selectedCategory === "blog" && group.handle === "resourceTypes"
							? "Blog"
							: selectedCategory?.groupHandle === group.handle
							? selectedCategory.title
							: group.label;

					return (
						<div
							key={label}
							className={clsx(
								"EntryFilter__categoryListbox mb-5 md:mb-0",
								"w-full lg:w-[400px]"
							)}
						>
							<CategoryMenu
								label={label}
								categories={group.categories}
								groupHandle={group.handle}
								selectedCategory={selectedCategory}
							/>
						</div>
					);
				})}
			</div>
			<SearchInput
				onCommit={handleSearch}
				isFetching={isFetching}
				initialValue={initialValue}
			/>
		</div>
	);
};

export default EntryFilter;
